import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AddEntry from './pages/AddEntry';
import SingleMountain from './pages/SingleMountain';
import SingleEntry from './pages/SingleEntry';
import MapWithSidebar from './pages/MapWithSidebar';
import Home from './pages/Home';
import { getMountain } from './utils/moutainDetails';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MapWithSidebar />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/glaciers/:mountainId',
        element: <SingleMountain />,
        loader: async ({ params }) => {
          return getMountain(params.mountainId);
        },
      },
      {
        path: '/glaciers/:mountainId/add',
        element: <AddEntry />,
        loader: async ({ params }) => {
          return getMountain(params.mountainId);
        },
      },
      {
        path: '/entries/:entryId',
        element: <SingleEntry />,
      },
    ],
  },
  {
    path: '/ticker',
    element: <>ticker comes here</>,
  },
]);

const AppRouter = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;
